<script>
import { renderRichText } from "@storyblok/svelte";
import { getHref, mySchema } from '$lib/storyblok';
import { page } from '$app/stores';  

export let algemeen;

// Move the subscription code inside this component
let currentPage;
const unsubscribe = page.subscribe(value => {
  currentPage = value;
});

let bgColor = "";

if(currentPage.data.story && currentPage.data.story.content.kleur) {
  bgColor = "background-" + currentPage.data.story.content.kleur;
}

$: adresgegevens = renderRichText(algemeen.content.extragegevens, { schema: mySchema });
var currentYear = new Date().getFullYear();
</script>
<footer class="{bgColor}">
    <div class="container">
      {#if algemeen.content.titel}
        <div class="col-span-4">
          <h3>{@html algemeen.content.titel}</h3>
        </div>
      {/if}
      <div class="grid md:grid-cols-3 gap-[30px]">
        <div class="adresgegevens-holder">
          <div class="adresgegevens mb-[30px]">
            {#if algemeen.content.straatnaam_huisnummer}
              {algemeen.content.straatnaam_huisnummer}<br>
            {/if}
            {#if algemeen.content.postcode}
              {algemeen.content.postcode}
            {/if}
            {#if algemeen.content.plaats}
              {algemeen.content.plaats}
            {/if}
          </div>

          <div class="adresgegevens mb-[30px]">{@html adresgegevens}</div>
          {#if algemeen.content.eMailadres || algemeen.content.telefoonnummer}
          <div>
            {#if algemeen.content.telefoonnummer}
            <div>
              <div class="icon-holder">
                <svg width="16px" height="22px" viewBox="0 0 16 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Ontwerp-Pluzpunt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Homepage---Ficare" transform="translate(-1260.000000, -14.000000)">
                            <g id="Group-11" transform="translate(1261.000000, 15.000000)">
                                <g id="smartphone-(1)" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.66666667">
                                    <g id="Group-10">
                                        <rect id="Rectangle" x="0" y="0" width="14" height="20" rx="1.66666667"></rect>
                                    </g>
                                </g>
                                <rect id="Rectangle" fill="#222" x="6" y="15" width="2" height="2" rx="1"></rect>
                            </g>
                        </g>
                    </g>
                </svg>
              </div>
              <a href="tel:{algemeen.content.telefoonnummer}">{algemeen.content.telefoonnummer}</a>
            </div>
            {/if}
            {#if algemeen.content.emailadres}
            <div>
              <div class="icon-holder">
                <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Ontwerp-Pluzpunt" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
                        <g id="Homepage---Ficare" transform="translate(-1415.000000, -18.000000)" stroke="#222" stroke-width="1.66666667">
                            <g id="mail-(1)" transform="translate(1416.000000, 19.000000)">
                                <path d="M1.66666667,0 L15,0 C15.9166667,0 16.6666667,0.75 16.6666667,1.66666667 L16.6666667,11.6666667 C16.6666667,12.5833333 15.9166667,13.3333333 15,13.3333333 L1.66666667,13.3333333 C0.75,13.3333333 0,12.5833333 0,11.6666667 L0,1.66666667 C0,0.75 0.75,0 1.66666667,0 Z" id="Path" stroke-linecap="round"></path>
                                <polyline id="Path" points="16.6666667 1.66666667 8.33333333 7.5 0 1.66666667"></polyline>
                            </g>
                        </g>
                    </g>
                </svg>
              </div>
              <a href="mailto:{algemeen.content.emailadres}">{algemeen.content.emailadres}</a>
            </div>
            {/if}
          </div>
          {/if}
        </div>
        <div>
          {#if algemeen.content.footermenu}
          <div class="footer-menu ">
            <ul>
              {#each algemeen.content.footermenu as item }
                <li>
                  {#if item.link.target == "_blank"}
                    <a href={getHref(item.link)} target="_blank" >{item.naam}</a>
                  {:else}
                    <a href={getHref(item.link)} >{item.naam}</a>
                  {/if}
                </li>
              {/each}
            </ul>
          </div>
          {/if}
        </div>
        <div>
          <ul class="social-list">
            {#if algemeen.content.facebook}
            <li><a class="social-button" target="_blank" href={algemeen.content.facebook}>
              <svg width="24" height="24" viewBox="0 0 20 20"><path d="M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z"></path></svg>
            </a></li>
            {/if}
            {#if algemeen.content.instagram}
            <li><a class="social-button" target="_blank" href={algemeen.content.instagram}>
              <svg width="24" height="24" viewBox="0 0 20 20"><path d="M13.55,1H6.46C3.45,1,1,3.44,1,6.44v7.12c0,3,2.45,5.44,5.46,5.44h7.08c3.02,0,5.46-2.44,5.46-5.44V6.44 C19.01,3.44,16.56,1,13.55,1z M17.5,14c0,1.93-1.57,3.5-3.5,3.5H6c-1.93,0-3.5-1.57-3.5-3.5V6c0-1.93,1.57-3.5,3.5-3.5h8 c1.93,0,3.5,1.57,3.5,3.5V14z"></path><circle cx="14.87" cy="5.26" r="1.09"></circle><path d="M10.03,5.45c-2.55,0-4.63,2.06-4.63,4.6c0,2.55,2.07,4.61,4.63,4.61c2.56,0,4.63-2.061,4.63-4.61 C14.65,7.51,12.58,5.45,10.03,5.45L10.03,5.45L10.03,5.45z M10.08,13c-1.66,0-3-1.34-3-2.99c0-1.65,1.34-2.99,3-2.99s3,1.34,3,2.99 C13.08,11.66,11.74,13,10.08,13L10.08,13L10.08,13z"></path></svg>
            </a></li>
            {/if}
            {#if algemeen.content.linkedin}
            <li><a class="social-button" target="_blank" href={algemeen.content.linkedin}>
              <svg width="24" height="24" viewBox="0 0 20 20"><path d="M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z"></path><path d="M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z"></path></svg>
            </a></li>
            {/if}
            {#if algemeen.content.x}
            <li><a class="social-button" target="_blank" href={algemeen.content.x}>
              <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="30-08-2023-Doorontwikkeling-website-2023-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="1-1-Homepage" transform="translate(-557.319223, -4686.000000)" fill="#000">
                          <g id="Group-20" transform="translate(0.000000, 4439.000000)">
                              <g id="Group-23" transform="translate(360.319223, 230.000000)">
                                  <g id="Group-16" transform="translate(180.000000, 0.000000)">
                                      <g id="Fill-3" transform="translate(17.000000, 17.000000)">
                                          <path d="M15.7514009,0 L10.6970623,6.07129103 L6.32789947,0 L0,0 L7.5607064,10.3918659 L0.394888776,19 L3.46323654,19 L8.99473595,12.3585216 L13.8284089,19 L20,19 L12.1183563,8.04865449 L18.8182204,0 L15.7514009,0 Z M3.58133809,1.82834734 L5.40499236,1.82834734 L16.3745967,17.0708214 L14.6748175,17.0708214 L3.58133809,1.82834734 Z" id="Fill-1"></path>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </svg>
            </a></li>
            {/if}
            {#if algemeen.content.vimeo}
            <li><a class="social-button" target="_blank" href={algemeen.content.vimeo}>
              <svg width="24" height="24" viewBox="0 0 20 20"><path d="M2.065,7.59C1.84,7.367,1.654,7.082,1.468,6.838c-0.332-0.42-0.137-0.411,0.274-0.772c1.026-0.91,2.004-1.896,3.127-2.688 c1.017-0.713,2.365-1.173,3.286-0.039c0.849,1.045,0.869,2.629,1.084,3.891c0.215,1.309,0.421,2.648,0.88,3.901 c0.127,0.352,0.37,1.018,0.81,1.074c0.567,0.078,1.145-0.917,1.408-1.289c0.684-0.987,1.611-2.317,1.494-3.587 c-0.115-1.349-1.572-1.095-2.482-0.773c0.146-1.514,1.555-3.216,2.912-3.792c1.439-0.597,3.579-0.587,4.302,1.036 c0.772,1.759,0.078,3.802-0.763,5.396c-0.918,1.731-2.1,3.333-3.363,4.829c-1.114,1.329-2.432,2.787-4.093,3.422 c-1.897,0.723-3.021-0.686-3.667-2.318c-0.705-1.777-1.056-3.771-1.565-5.621C4.898,8.726,4.644,7.836,4.136,7.191 C3.473,6.358,2.72,7.141,2.065,7.59C1.977,7.502,2.115,7.551,2.065,7.59L2.065,7.59z"></path></svg>
            </a></li>
            {/if}
            {#if algemeen.content.youtube}
            <li><a class="social-button" target="_blank" href={algemeen.content.youtube}>
              <svg width="24" height="24" viewBox="0 0 20 20"><path d="M15,4.1c1,0.1,2.3,0,3,0.8c0.8,0.8,0.9,2.1,0.9,3.1C19,9.2,19,10.9,19,12c-0.1,1.1,0,2.4-0.5,3.4c-0.5,1.1-1.4,1.5-2.5,1.6 c-1.2,0.1-8.6,0.1-11,0c-1.1-0.1-2.4-0.1-3.2-1c-0.7-0.8-0.7-2-0.8-3C1,11.8,1,10.1,1,8.9c0-1.1,0-2.4,0.5-3.4C2,4.5,3,4.3,4.1,4.2 C5.3,4.1,12.6,4,15,4.1z M8,7.5v6l5.5-3L8,7.5z"></path></svg>
            </a></li>
            {/if}
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="grid md:grid-cols-2">
          <div>
            {#if algemeen.content.disclaimermenu}
            <div class="disclaimer-menu">
              <ul>
                {#each algemeen.content.disclaimermenu as item}
                <li>
                  {#if item.link.target == "_blank"}
                    <a href={getHref(item.link)} target="_blank" >{item.naam}</a>
                  {:else}
                    <a href={getHref(item.link)} >{item.naam}</a>
                  {/if}
                </li>
                {/each}
              </ul>
            </div>
            {/if}
          </div>
          {#if algemeen.content.disclaimer_tekst}
          <div>
            <div class="year-holder">
              {@html algemeen.content.disclaimer_tekst} 
              {#if algemeen.content.toon_jaartal}
              <span>{currentYear}</span>
              {/if}
            </div>
          </div>
          {/if}
        </div>
      </div>
    </div>
</footer>
<style lang="postcss">
footer {
    background-color: var(--footer-background);
    color: var(--footer-color);
    padding: 90px 0;

    h3 {
      color: var(--footer-title-color);
    }
  }
  
  .footer-menu {
    max-width: 260px;
    margin: 0 auto;
    ul {
      list-style: disc;
      margin: 0;
      padding: 0;
      
      li {
        margin-bottom: 7px;
      }
      
      a {
        color: var(--footer-color);
        text-decoration: none !important;
        transition: all .4s;
        
        &:hover {
          color: var(--white);
        }
      }
    }
  }
  
  .footer-bottom {
    margin-top: 75px;
    font-size: 14px;
    
    .disclaimer-menu {
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
          display: inline-block;
          line-height: 16px;
          
          &:not(:last-child) {
            margin-right: 15px;
            padding-right: 15px;
            position: relative;

            &::before {
              content: '';
              width: 1px;
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
              background-color: var(--footer-color);
            }
          }
          
          a {
            color: var(--footer-color);
            text-decoration: none !important;
            transition: all .4s;
            
            &:hover {
              color: var(--white);
            }
          }
        }
      }
    }
  }
  
  .year-holder {
    text-align: right;
  }
  
  .social-list {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: right;
    
    li {
      display: inline-block;
      margin-bottom: 10px;
      
      &:not(:first-child) {
        margin-left: 10px;
      }
      
      a.social-button {
        box-sizing: border-box;
        width: 36px;
        height: 36px;
        vertical-align: middle;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 0;
        transition: all .3s;
        background-color: var(--social-background);
        border: 2px solid var(--social-border);

        svg {
          * {
            fill: var(--social-icon-color);
            transition: all .3s;
          }
        }
      }
      
      &:hover a.social-button {
        background-color: var(--social-hover-background);
        border: 2px solid var(--social-hover-background);

        svg {
          * {
            fill: var(--social-hover-icon-color);
            transition: all .3s;
          }
        }
      }
    }
  }
  
  .adresgegevens-holder .icon-holder {
    min-width: 20px;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    vertical-align: middle;
  }
  
  .adresgegevens-holder a {
    color: var(--footer-color);
    text-decoration: none !important;
    transition: all .4s;
    
    &:hover {
      color: var(--white);
    }
  }

  footer .icon-holder svg * {
    stroke: var(--black);
  }

  @media only screen and (max-width: 1024px) {
    footer {
      padding: 75px 0;
    }
  }
  
  @media only screen and (max-width: 767px) {
    footer {
      padding: 50px 0;
    }
    
    .social-list {
      text-align: left;
    }
    
    .footer-menu {
      float: unset;
      margin: 0 0 0 20px;
    }
    
    .year-holder {
      text-align: left;
    }
    
    .footer-bottom {
      margin-top: 35px;
    }
  }
</style>